{
  "builderIOApiKey": "replace-me-default-key",
  "dynamicBuilderIOApiKey": "",
  "flavorEnv": {
    "fr-main": {
      "builderIOApiKey": "b1fc51f68c594d1a8feb8be8be23fbc6"
    },
    "es-main": {
      "builderIOApiKey": "89b033af35414942acd6de4559c0ebdf"
    },
    "it-main": {
      "builderIOApiKey": "8a14c0e074ab4866bd785c82f7053328"
    },
    "fr-testing": {
      "builderIOApiKey": "ce19d97e44954c25844c3847389ed485"
    },
    "es-testing": {
      "builderIOApiKey": "b61dd5957315435284ee82d5f9af2862"
    },
    "it-testing": {
      "builderIOApiKey": "8a14c0e074ab4866bd785c82f7053328"
    }
  },
  "env": "main",
  "flavor": "es"
}